import React from 'react';

const BottomNavGuarantee = ({ details }) => {
  return (
    <div className="bottom-nav-guarantee">
      <i className="fa fa-check-circle" />
      <h5>100% money-back guarantee</h5>
      <p>{ details }</p>
    </div>
  );
}

export default BottomNavGuarantee;



// WEBPACK FOOTER //
// ./pap/components/common/bottom_nav_guarantee.jsx